export { default } from './Settings.container'



// WEBPACK FOOTER //
// ./src/pages/Settings/index.js